/**
 * Helper for confirmation dialogs (Telegram WebApp compatible)
 *
 * This function attempts to use Telegram WebApp's showConfirm method if available
 * and the WebApp version is 6.2+. Otherwise, it falls back to native browser confirm.
 *
 * @param {string} message - The confirmation message to display
 * @returns {Promise<boolean>} - Promise that resolves to true if confirmed, false otherwise
 */
export function showConfirm(message) {
  return new Promise(resolve => {
    try {
      const tgWebApp = window.Telegram?.WebApp

      // showConfirm internally uses showPopup, which requires version 6.2+
      // Check if version is at least 6.2 before using showConfirm
      if (tgWebApp?.showConfirm && typeof tgWebApp.showConfirm === 'function') {
        // Check if version supports showPopup (required for showConfirm)
        if (tgWebApp.isVersionAtLeast && typeof tgWebApp.isVersionAtLeast === 'function') {
          if (tgWebApp.isVersionAtLeast('6.2')) {
            try {
              window.Telegram.WebApp.showConfirm(message, confirmed => {
                resolve(confirmed)
              })
              return
            } catch (e) {
              // If showConfirm fails, fallback to native confirm
              resolve(confirm(message))
              return
            }
          }
        }
      }
      // Fallback to native confirm (for version < 6.2 or when showConfirm is not available)
      resolve(confirm(message))
    } catch (e) {
      // If anything fails, fallback to native confirm
      resolve(confirm(message))
    }
  })
}
